import "./hazardous-goods.css";
import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import ViewQuillComponent from "../../../dashboard/admin/textos/viewQuillComponent";
import folletoPdfEs from "../../../../assets/pdfs/prohibited_16_11_2021_esp.pdf";

function HazardousGoods() {
  const { i18n } = useTranslation();

  const idComponent = "1c77175f-5556-4d23-8d5c-885fe9196efa";
  const idComponentNoAccepted = "50c1bc14-7da9-4592-a7a8-009b58af3621";

  const currentLng = i18n.language || localStorage.getItem("lng") || "es";
  const isEnglish = currentLng.includes("en") || currentLng.includes("us");
  const redirectPath = isEnglish ? "/quote" : "/cotizar";

  const downloadText = isEnglish
    ? "Download the information booklet"
    : "Descarga nuestro folleto informativo";

  const quoteText = isEnglish ? "GET A QUOTE" : "COTIZAR";

  const [dataInformation, setDataInformation] = useState(null);
  const [dataInformationNoAccepted, setDataInformationNoAccepted] =
    useState(null);

  const loadTexts = useCallback(async () => {
    try {
      const activeLanguage =
        i18n.language || localStorage.getItem("lng") || "es";
      const isEn =
        activeLanguage.includes("en") || activeLanguage.includes("us");

      const [resAccepted, resNoAccepted] = await Promise.all([
        axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idComponent}`,
          {
            headers: {
              Authorization: process.env.REACT_APP_PUBLIC_KEY,
            },
          },
        ),
        axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idComponentNoAccepted}`,
          {
            headers: {
              Authorization: process.env.REACT_APP_PUBLIC_KEY,
            },
          },
        ),
      ]);

      const dataAcc = resAccepted.data?.textWeb;
      const dataNoAcc = resNoAccepted.data?.textWeb;

      // Console.logs para inspeccionar la respuesta en el navegador
      console.log(
        "--> Idioma detectado en loadTexts:",
        activeLanguage,
        "| Es ingles?:",
        isEn,
      );
      console.log("--> Contenido Aceptados (text_us):", dataAcc?.text_us);
      console.log("--> Contenido No Aceptados (text_us):", dataNoAcc?.text_us);

      if (isEn) {
        setDataInformation(dataAcc?.text_us);
        setDataInformationNoAccepted(dataNoAcc?.text_us);
      } else {
        setDataInformation(dataAcc?.text_es);
        setDataInformationNoAccepted(dataNoAcc?.text_es);
      }
    } catch (error) {
      console.error("Error fetching hazardous goods texts:", error);
    }
  }, [i18n.language]);

  useEffect(() => {
    loadTexts();

    // Escuchar el evento de cambio de idioma nativo de i18next
    const handleLanguageChange = () => {
      loadTexts();
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [loadTexts, i18n]);

  return (
    <>
      <div className="hazardous-container">
        <div className="item-content">
          <div className="header">
            {dataInformation && (
              <ViewQuillComponent
                content={dataInformation?.["01-titulo"]?.content}
                type={"json"}
              />
            )}
          </div>

          <div className="info-content">
            {dataInformation && (
              <ViewQuillComponent
                content={dataInformation?.["02-sub-titulo"]?.content}
                type={"json"}
              />
            )}

            <br />
            {dataInformation && (
              <ViewQuillComponent
                content={dataInformation?.["03-texto-ejemplos"]?.content}
                type={"json"}
              />
            )}

            <div className="items-points">
              {dataInformation && (
                <ViewQuillComponent
                  content={dataInformation?.["04-puntos-1"]?.content}
                  type={"json"}
                />
              )}

              {dataInformation && (
                <ViewQuillComponent
                  content={dataInformation?.["05-puntos-2"]?.content}
                  type={"json"}
                />
              )}
            </div>
          </div>
        </div>

        <div className="item-content">
          <div className="header">
            {dataInformationNoAccepted && (
              <ViewQuillComponent
                content={dataInformationNoAccepted?.["01-titulo"]?.content}
                type={"json"}
              />
            )}
          </div>

          <div className="info-content">
            {dataInformationNoAccepted && (
              <ViewQuillComponent
                content={dataInformationNoAccepted?.["02-sub-titulo"]?.content}
                type={"json"}
              />
            )}

            <br />

            <div className="items-points">
              {dataInformationNoAccepted && (
                <ViewQuillComponent
                  content={dataInformationNoAccepted?.["04-puntos-1"]?.content}
                  type={"json"}
                />
              )}

              {dataInformationNoAccepted && (
                <ViewQuillComponent
                  content={dataInformationNoAccepted?.["05-puntos-2"]?.content}
                  type={"json"}
                />
              )}
            </div>

            <div className="download-infomated-format">
              <a
                href={folletoPdfEs}
                download="Folleto_Mercancias_Peligrosas.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                {downloadText}
              </a>

              <button
                onClick={() => (window.location.href = redirectPath)}
                className="quote-btn"
              >
                {quoteText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HazardousGoods;
